const initialState = {
  customer: {
    id: '',
    name: '',
  },
  date: '',
  time: {
    start: '',
  },
  place: {
    name: '',
    address: '',
  }
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'RETRIEVED_SCHEDULING_PRINT':
      return { ...action.payload };
    case 'CLEAR_SCHEDULING_PRINT':
      return { ...initialState };
    default:
      return state;
  }
}
